<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <div class="page-btn d-flex justify-content-end mb-3">
          <button
              class="btn btn-added add-permission-btn d-flex align-items-center"
              @click="openAddPermissionModal"
          >
            <img src="@/assets/img/icons/plus.svg" class="me-2" alt="Add"/>
            Add Permission
          </button>
        </div>


        <!-- /Permission list -->
        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-set">
                <div class="search-input">
                  <a class="btn btn-searchset"><img src="../../../../assets/img/icons/search-white.svg" alt="img"/></a>
                  <div id="DataTables_Table_0_filter" class="dataTables_filter">
                    <label>
                      <input type="search" class="form-control form-control-sm" placeholder="Search..."
                             aria-controls="DataTables_Table_0" v-model="searchText"/>
                    </label>
                  </div>
                </div>
              </div>
              <div class="wordset">
                <ul>
                  <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="pdf"><img
                        src="../../../../assets/img/icons/pdf.svg" alt="img"/></a>
                  </li>
                  <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"><img
                        src="../../../../assets/img/icons/excel.svg" alt="img"/></a>
                  </li>
                  <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="print"><img
                        src="../../../../assets/img/icons/printer.svg" alt="img"/></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="table-responsive">
              <a-table :columns="columns" :data-source="filteredData" :filters="['name']">
                <template #bodyCell="{ column, record }">
                  <!--                  <template v-if="column.key === 'id'">-->
                  <!--                    <span class="badges bg-lightgreen">{{-->
                  <!--                        record.Status-->
                  <!--                      }}</span></template>-->

                  <template v-if="column.key === 'action'">
                    <div class="text-end">
                      <a class="me-3" href="javascript:void(0);" @click="openAddPermissionModal(record)">
                        <img src="../../../../assets/img/icons/edit.svg" alt="img"/>
                      </a>
<!--                      <a class="me-3 confirm-text" href="javascript:void(0);" @click="showAlert">-->
<!--                        <img src="../../../../assets/img/icons/delete.svg" alt="img"/>-->
<!--                      </a>-->
                    </div>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <!-- /product list -->
      </div>
    </div>
  </div>

  <PermissionModal
      :permissionProps="permission"
      @updateCompleted="getPermissions"
  />
</template>

<script>
import store from '@/store';
import PermissionModal from "./add-permission.vue";
import Restock from "@/views/pages/product/modals/restock.vue";

const columns = [
  // {
  //   sorter: true,
  // },
  {
    title: "Name",
    dataIndex: "name",
    sorter: {
      compare: (a, b) => {
        a = a.role.toLowerCase();
        b = b.role.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Code",
    dataIndex: "code",
    sorter: {
      compare: (a, b) => {
        a = a.code.toLowerCase();
        b = b.code.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Description",
    dataIndex: "description",
    sorter: (a, b) => a.description.localeCompare(b.description),
  },
  {
    title: "Action",
    key: "action",
    class: "text-end",
    sorter: true,
  },
];

export default {
  components: {Restock, PermissionModal},
  data() {
    return {
      filter: false,
      searchText: "",
      title: "Permissions",
      title1: "Manage Permissions",
      items: [
        {
          text: "Add permission",
          addname: "/addPermission",
        },
      ],
      data: [],
      columns,
      permission: null
    };
  },

  computed: {
    filteredData() {
      if (!this.searchText) return this.data;

      const lower = this.searchText.toLowerCase();
      return this.data.filter(
          (item) =>
              item.name.toLowerCase().includes(lower) ||
              item.code.toLowerCase().includes(lower) ||
              item.description.toLowerCase().includes(lower)
      );
    }
  },

  methods: {
    getPermissions() {
      store.dispatch("adminPermission/get").then((response) => {
        this.data = response.data.data;
      });
    },

    openAddPermissionModal(permission) {
      this.permission = permission;
      console.log("Permission", this.permission)
      $("#permissionModal").modal("show");
    }
  },

  mounted() {
    this.getPermissions();
  },
  name: "permissions",
};
</script>
<style scoped>
.add-permission-btn {
  background-color: #ff9f43;
  border: none;
  color: #fff;
  padding: 8px 16px;
  border-radius: 6px;
}

.add-permission-btn:hover {
  background-color: #e68e35; /* darker hover */
}

/* give spacing so it's not stuck to the border */
.page-btn {
  padding-right: 12px;
}
</style>
